import React, { useEffect } from "react";
import "./product.css";
import builingSeftyntes from "../assets/buildingseafty.jpg";
import sportnets from "../assets/sportsnet.jpg";
import mokeySeaftynets from "../assets/monkeySeaftynets.jpg";
import petsSeaftyNets from "../assets/galleryassests/8.jpg";
import industrialSeaftyNets from "../assets/industrialSeaftyNets.jpg";
import ductareaNets from "../assets/ductareanets.webp";
import childerSeaftyNets from "../assets/childerSeaftynets.jpg";
import invisibleGrills from "../assets/invisiblegrills/main.jpg";
import birdspikes from "../assets/birdspikes.jpg";
import FAQSection from "../global/FAQSection";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const products = [
  {
    id: 9,
    name: "Invisible Grills",
    image: invisibleGrills,
    description:
      "Stylish and secure invisible grills that offer safety with an unobstructed view.",
    features: ["Rust resistant", "High tensile strength", "Elegant design"],
    path: "/invisiblegrills",
  },
  {
    id: 1,
    name: "Balcony Safety Nets",
    image: builingSeftyntes,
    description:
      "Safety nets designed to protect children and pets from balconies.",
    features: ["UV resistant", "Durable mesh", "Easy installation"],
    path: "/balconysafenets",
  },
  {
    id: 2,
    name: "Children Safety Nets",
    image: childerSeaftyNets,
    description: "Safety nets for protecting children from falls or accidents.",
    features: ["Non-toxic", "High tensile strength", "Weather resistant"],
    path: "/childernsafetynets",
  },
  {
    id: 3,
    name: "Industrial Safety Nets",
    image: industrialSeaftyNets,
    description: "Heavy-duty nets designed for industrial safety applications.",
    features: ["Chemical resistant", "Extra strength", "Fire retardant"],
    path: "/industrialsafetynets",
  },
  {
    id: 4,
    name: "Pets Safety Nets",
    image: petsSeaftyNets,
    description:
      "Protect your pets from falling or escaping with these safety nets.",
    features: ["Pet-friendly", "Heavy-duty", "Weatherproof"],
    path: "/petssafetynets",
  },
  {
    id: 5,
    name: "Duct  area Nets",
    image: ductareaNets,
    description: "Nets designed for duct areas to prevent debris and pests.",
    features: ["Dust resistant", "Easy to clean", "Durable"],
    path: "/ducterianets",
  },
  {
    id: 6,
    name: "Monkey Safety Nets",
    image: mokeySeaftynets,
    description: "Nets to prevent monkeys from entering certain areas.",
    features: ["Strong mesh", "Animal-resistant", "Weather-resistant"],
    path: "/monkeysafetynets",
  },
  {
    id: 7,
    name: "Cricket Practice Nets",
    image: sportnets,
    description:
      "Practice nets for cricket players, offering safety and convenience.",
    features: ["Weather resistant", "Professional grade", "Durable netting"],
    path: "/cricketpracticenets",
  },
  {
    id: 8,
    name: "Bird Spikes",
    image: birdspikes,
    description: "Spikes designed to prevent birds from landing on surfaces.",
    features: ["Non-toxic", "Easy installation", "Durable material"],
    path: "/birdspikes",
  },
];

export default function Products() {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth", // Optional: Adds a smooth scrolling effect
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>Expertise - ANS Safety Nets</title>
        <meta
          name="description"
          content="Discover the expertise of ANS Safety Nets in providing high-quality safety nets and solutions in Bengaluru. We specialize in various safety nets including balcony, children, industrial, pets, and more."
        />
        <meta
          name="keywords"
          content="Expertise in Safety Nets, Safety Nets in Bengaluru, Balcony Safety Nets in Bengaluru, Children Safety Nets in Bengaluru, Industrial Safety Nets in Bengaluru, Pets Safety Nets in Bengaluru, Ducteria Nets in Bengaluru, Monkey Safety Nets in Bengaluru, Cricket Practice Nets in Bengaluru, Bird Spikes in Bengaluru, Safety Solutions in Bengaluru"
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <meta name="email" content="anssafetynets@gmail.com" />
        <meta name="phone" content="+91- 7416116587" />
        <link rel="canonical" href="https://www.anssafetynets.com/expertise" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Expertise - ANS Safety Nets",
            url: "https://www.anssafetynets.com/expertise",
            description:
              "Discover the expertise of ANS Safety Nets in providing high-quality safety nets and solutions in Bengaluru. We specialize in various safety nets including balcony, children, industrial, pets, and more.",
            keywords: [
              "Expertise in Safety Nets",
              "Safety Nets in Bengaluru",
              "Balcony Safety Nets in Bengaluru",
              "Children Safety Nets in Bengaluru",
              "Industrial Safety Nets in Bengaluru",
              "Pets Safety Nets in Bengaluru",
              "Ducteria Nets in Bengaluru",
              "Monkey Safety Nets in Bengaluru",
              "Cricket Practice Nets in Bengaluru",
              "Bird Spikes in Bengaluru",
              "Safety Solutions in Bengaluru",
              "safety nets in bengaluru",
              "ans safety nets",
              "ans safety nets in bengaluru",
              "balcony safety nets",
              "balcony safety nets in bengaluru",
              "pigeon safety nets",
              "pigeon safety nets in bengaluru",
              "industrial safety nets",
              "industrial safety nets in bengaluru",
              "bird spikes",
              "bird spikes in bengaluru",
              "sports nets",
              "sports nets in bengaluru",
              "building covering nets",
              "building covering nets in bengaluru",
              "pets safety nets",
              "pets safety nets in bengaluru",
              "ducteria nets",
              "ducteria nets in bengaluru",
              "children safety nets",
              "children safety nets in bengaluru",
              "cricket practice nets",
              "cricket practice nets in bengaluru",
            ],
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.anssafetynets.com",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Expertise",
                  item: "https://www.anssafetynets.com/expertise",
                },
              ],
            },
            publisher: {
              "@type": "Organization",
              name: "ANS Safety Nets",
              logo: {
                "@type": "ImageObject",
                url: "https://www.anssafetynets.com/logo.png",
                width: 250,
                height: 100,
              },
              contactPoint: {
                "@type": "ContactPoint",
                telephone: "+91-7416116587",
                contactType: "Customer Service",
                areaServed: "IN",
                availableLanguage: ["English", "Kannada"],
              },
              sameAs: [
                "https://www.facebook.com/profile.php?id=61572534324956",
                "https://www.instagram.com/anssafetynets_bengaluru/",
              ],
            },
            service: [
              {
                "@type": "Service",
                name: "Balcony Safety Nets",
                areaServed: "Bengaluru",
              },
              {
                "@type": "Service",
                name: "Children Safety Nets",
                areaServed: "Bengaluru",
              },
              {
                "@type": "Service",
                name: "Pets Safety Nets",
                areaServed: "Bengaluru",
              },
              {
                "@type": "Service",
                name: "Industrial Safety Nets",
                areaServed: "Bengaluru",
              },
              {
                "@type": "Service",
                name: "Monkey Safety Nets",
                areaServed: "Bengaluru",
              },
              {
                "@type": "Service",
                name: "Cricket Practice Nets",
                areaServed: "Bengaluru",
              },
              {
                "@type": "Service",
                name: "Bird Spikes",
                areaServed: "Bengaluru",
              },
            ],
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
              addressLocality: "Bengaluru",
              addressRegion: "KA",
              postalCode: "560013",
              addressCountry: "IN",
            },
          })}
        </script>
      </Helmet>
      <div className="pt-16">
        {/* Hero Section */}
        <div className="bg-[#2c3639] py-20 h-[600px] flex flex-col justify-center items-center relative">
          <div className="bg-[#2c3639] py-20 h-[600px] flex flex-col justify-center items-center relative">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-white mb-4">
                We Are Experts In
              </h1>
              <p className="text-xl text-white">
                Providing high-quality safety nets for every application
              </p>
            </div>
            <button
              className="absolute bottom-10 text-white text-7xl animate-bounce"
              onClick={() => {
                document.getElementById("nextSection").scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              ↓
            </button>
          </div>
        </div>

        <div className="py-20 " id="nextSection">
          <div className="max-w-7xl mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {products.map((product) => (
                <div
                  key={product.id}
                  className="bg-white rounded-lg shadow-md overflow-hidden productCard"
                >
                  <img
                    src={product.image}
                    alt="ANS SAFETY NETS ,safety nets in bengaluru,"
                    tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
    Children Safety Nets,
    Industrial Safety Nets,
    Pets Safety Nets,
    Ducteria Nets,
    Monkey Safety Nets,
    Cricket Practice Nets,
    Bird Spikes"
                    className="w-full h-64 object-cover"
                    loading="lazy"
                  />
                  <div className="p-6 pt-3">
                    <h3 className="text-2xl font-semibold mb-1">
                      {product.name}
                    </h3>
                    <p className="text-gray-600 mb-2">{product.description}</p>
                    <ul className="space-y-1">
                      {product.features.map((feature, index) => (
                        <li
                          key={index}
                          className="flex items-center text-gray-600"
                        >
                          <span className="h-2 w-2 bg-[#2c3639] rounded-full mr-2"></span>
                          {feature}
                        </li>
                      ))}
                      <button
                        className="cardStylingbutton"
                        onClick={() => {
                          navigate(product.path);
                          window.scrollTo({
                            top: 0,
                            behavior: "smooth", // Optional: Adds a smooth scrolling effect
                          });
                        }}
                      >
                        Explore
                      </button>
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Customer Reviews Section */}
        {/* <TestimonialSwiper /> */}

        {/* Frequently Asked Questions (FAQ) */}
        <div className="bg-gray-100 py-10">
          <div className="max-w-7xl mx-auto px-2 ">
            <h2 className="text-3xl font-bold mb-6 text-center">
              Frequently Asked Questions
            </h2>
            <FAQSection />
          </div>
        </div>
      </div>
    </>
  );
}
